/* eslint-disable import/order */
import { editWorkflowEntryPoint } from '@jira/admin-pages__edit-workflow/src/editWorkflowEntryPoint.entrypoint.tsx';
import { workflowUserPreferencesResource } from '@jira/router-resources__admin-pages-workflows-user-preferences/src/useCollapseTransitionLabelsPreferenceFromResource.tsx';
import { workflowCapabilitiesResource } from '@jira/router-resources__admin-pages-workflows-workflow-capabilities/src/workflowCapabilitiesResource.tsx';
import { workflowDocumentResource } from '@jira/router-resources__admin-pages-workflows-workflow-document/src/workflowDocumentResource.tsx';
import { workflowBuilderProvisioningResource } from '@jira/router-resources__admin-pages-workflows-workflow-builder-provisioning/src/useWorkflowBuilderProvisioning.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalSettingsIssueWorkflowEditRoute } from '@jira/router-routes__admin-pages-workflows-routes/src/globalSettingsIssueWorkflowEditRoute.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import type { Route } from '@atlassian/react-resource-router';

const globalSettingsIssueWorkflowEditEntryPoint = createChromelessEntryPoint({
	main: editWorkflowEntryPoint,
});

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const globalSettingsIssueWorkflowEditRouteEntry: Route = createEntry(
	globalSettingsIssueWorkflowEditRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.edit-workflow',

		entryPoint: () => globalSettingsIssueWorkflowEditEntryPoint,
		skeleton: Spinner,
		// eslint-disable-next-line no-restricted-syntax
		component: undefined,
		layout: chromelessLayout,
		navigation: undefined,
		resources: [
			workflowCapabilitiesResource,
			workflowDocumentResource,
			...jiraSpaResources(),
			rovoEntitlementResource,
			workflowUserPreferencesResource,
			...getWorkflowBuilderProvisioningResources(),
		],

		forPaint: undefined,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
